import FileSaver from 'file-saver'
import { AudioFileExtension } from '../../enums/AudioFileExtension'
import { audioFileMimeTypes } from '../../constants/audioFileMimeTypes'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { getPossibleErrorMessage } from '../../functions/getPossibleErrorMessage'

export function downloadAudioFile(
  parts: BlobPart[],
  { extension, filename }: { extension: AudioFileExtension; filename: string },
) {
  const name = `${filename}.${extension}`

  try {
    const blob = new Blob(parts, {
      type: audioFileMimeTypes[extension],
    })

    FileSaver.saveAs(blob, name)
  } catch (reason: any) {
    logger.log(LogActionType.DownloadFileDownloadingError, getPossibleErrorMessage(reason))
  } finally {
    logger.log(LogActionType.DownloadFileDownloaded, { name })
  }
}
